import multiPermissions from './versions/multi-permissions'
import legacy from './versions/legacy'

export default {
  '1.0.0': legacy,
  '1.5.0': multiPermissions,
  '1.5.1': multiPermissions,
  '1.5.2': multiPermissions,
  '1.5.3': multiPermissions,
  '1.5.4': multiPermissions
}
